/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import FieldGroup from '../../FieldGroup.js'
import Translation from '../../../store/internationalization-store.js';
import {ClassesService} from '../../../services';

class UploadStudentsCSV extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };

        this.props.data.isMake = true;
    }

    validateClassName(className){
        this.props.data.name = className;
    }


    render(){

        return <div style={{padding:"20px"}}>
            <div>
                <FieldGroup  onChange={(event)=>{this.setState({saved:false, name:event.target.value}); this.props.data.name = event.target.value}} value={this.state.title} id="student-name" label={Translation.get(819 , "Class Name")}/>
            </div>
        </div>
    }


}


export default {
    name: function() {return Translation.get('819' ,'Class name' )},
    icon:<i class="fa-2x fas fa-keyboard"></i>,
    title:null,
    onSubmit: function (done){

        if(!this.props.data.name){
            return done(new Error(Translation.get('902' ,'Please Enter A Class Name' )));
        }
        else
        {
            ClassesService.doesNameExist(this.props.data.name).then(function(isValid){
                if(isValid) return  done();
                else done(new Error(Translation.get('901' ,'You all ready have a class with that name' )));
            })
        }

    },
    onBack:function(done){
        done();
    },
    component: UploadStudentsCSV
}